import type { DocumentTypeSectionsPayload } from '@Application/Organizations/Workflows/Actions/documentTypeSectionsFetched';
import DocumentTypeSectionView from '@UI/Store/OrganizationWorkflows/Views/DocumentTypeSectionView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * The template sections of one document type for one organization, scoped by `organizationId` and
 * `documentTypeId`. Empty, with null template ids, when the type has no template.
 */
class DocumentTypeSectionsView {
	readonly templateId: number | null;
	readonly templateVersionId: number | null;
	readonly sections: readonly DocumentTypeSectionView[];
	readonly organizationId: number;
	readonly documentTypeId: number;

	constructor(payload: DocumentTypeSectionsPayload, organizationId: number, documentTypeId: number) {
		this.templateId = payload.template?.id ?? null;
		this.templateVersionId = payload.templateVersion?.id ?? null;
		this.sections = payload.sections.map((section) => new DocumentTypeSectionView(section));
		this.organizationId = organizationId;
		this.documentTypeId = documentTypeId;

		Object.freeze(this);
	}

	get hasTemplate(): boolean {
		return this.templateId !== null;
	}
}

export default DocumentTypeSectionsView;
